import api from "../api";
import {iniciarRequisicao} from "../../helpers/index"

class ConfiguracoesAPI {
  async getConfiguracoesCompras() {
    const headers = iniciarRequisicao();
    return await api.get("/compras/configuracao", { headers });
  }

  async getConfigFornecedorCompra(id) {
    const headers = iniciarRequisicao();
    return await api.get(`/compras/configuracao/fornecedor/${id}`, { headers });
  }

  async setConfigFornecedorCompra(params) {
    const headers = iniciarRequisicao();
    return await api.put('/compras/configuracao/fornecedor', params, {headers});
  }
}

export default new ConfiguracoesAPI();
